<div class="w-full h-full">
  <app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
    <p-toolbar>
      <ng-template #start>
        <div class="flex gap-2 toolbar-menu">
          <p-selectButton
            [options]="resultsDisplay"
            [(ngModel)]="selectedResultDisplay"
            (onChange)="toggleGridPlot($event)"
            [allowEmpty]="false"
          ></p-selectButton>

          <p-select
            [options]="packers"
            appendTo="body"
            (onChange)="selectPacker($event)"
            [(ngModel)]="selectedPacker"
          ></p-select>

          @if (selectedResultDisplay === 'plot') {
            <p-select
              [options]="resultTypes"
              appendTo="body"
              (onChange)="toggleResultsView($event)"
              [(ngModel)]="selectedResultView"
            ></p-select>
          }

          @if (isDisplacementSelected || selectedResultDisplay === 'grid') {
            <div class="space-x-2">
              <p-select
                (onChange)="displacementTypeChange($event)"
                optionValue="value"
                optionLabel="label"
                [options]="displacementTypes"
                appendTo="body"
                [(ngModel)]="displacementType"
              ></p-select>

              <span>
                <i [pTooltip]="displacementTooltip" class="pi pi-info-circle cursor-help relative z-[2]"></i>
              </span>
            </div>
          }

          @if (showExpansionJointFocusToggle) {
            <div class="mb-1 flex items-center gap-2">
              <p-selectButton
                [(ngModel)]="expansionJointFocus"
                [options]="expansionJointFocusOptions"
                optionLabel="label"
                optionValue="value"
                (onChange)="showResults()"
                ariaLabel="Expansion joint focus"
                [allowEmpty]="false"
              ></p-selectButton>
              <i class="pi pi-info-circle text-muted-color cursor-help relative z-[2]" pTooltip="Shown only for true telescoping expansion joints (EJ enabled and depth set away from packer depth)."></i>
            </div>
          }
        </div>
      </ng-template>
      <ng-template #end>
        <span class="text-xs mr-2">* NOTE: Negative packer forces are in upward direction</span> 
      </ng-template>
    </p-toolbar>

    @if (!isLoading()) {
      <p-dialog
        [draggable]="false"
        [(visible)]="needToCalculate"
        [closable]="false"
        appendTo="self"
      >
        <i class="pi pi-exclamation-circle pr-1"></i>
        <label>Please calculate PERIVIS to see results</label>
        <br />
        <br />
      </p-dialog>
    }

    @if (!isLoading()) {
      <p-dialog
        [draggable]="false"
        [(visible)]="packersMissing"
        [closable]="false"
        appendTo="self"
      >
        <i class="pi pi-exclamation-circle pr-1"></i>
        <label>No Packers set on selected string.</label>
        <br />
        <br />
      </p-dialog>
    }

    @if (selectedResultDisplay === 'plot') {
      <app-xy-line-plot
        [plotData]="plot.data"
        [xAxisTitle]="xAxisTitle"
        [yAxisTitle]="yAxisTitle"
        [plotName]="plotName"
        [downloadPlotName]="downloadPlotName"
        [legendBelowPlot]="true"
        [plotTitle]="'Packer Results Table'"
        [hidden]="selectedResultDisplay !== 'plot'"
        [xyLinePlotStore]="packerResultsStore"
        [annotations]="annotations"
        [shapes]="shapes"
        [reverseAutoRange]="isDisplacementSelected"
      ></app-xy-line-plot>
    }

    <app-single-load-grid
      [hidden]="selectedResultDisplay !== 'grid'"
      [rowData]="displayResults"
      [columnDefinitions]="cols"
      [tableName]="'Packer Results Table'"
      [gridName]="'Packer Results Table'"
      [shearPinRating]="shearPinRating"
      [upwardMovementLimit]="upwardMovementLimit"
      [downwardMovementLimit]="downwardMovementLimit"
      [lengthUnit]="longLengthUnit"
    ></app-single-load-grid>

    @if (resultData != null) {
      <app-perivis-validation
        [errors]="resultData[0]?.errors"
      />
    }
  </app-tool-loader>
</div>
